import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
//import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

@Injectable()
export class WeatherService {

  constructor(public http:Http) { }

  getWeather(loc){
      return this.http.get('https://api.openweathermap.org/data/2.5/weather?q='+loc+'&lang=fr&units=metric&appid=f503b4a58a9712074372c8634ef724ae');
        // .do(console.log)
        // .map(res => res.json());
    }
  getWeekWeather(loc){
       return this.http.get('https://api.openweathermap.org/data/2.5/forecast?q='+loc+'&lang=fr&units=metric&appid=f503b4a58a9712074372c8634ef724ae');
  }

}

//api.openweathermap.org/data/2.5/forecast?q=strasbourg,fr&appid=f503b4a58a9712074372c8634ef724ae&units=metric
// f503b4a58a9712074372c8634ef724ae
// 9068a84f334223c4d062501b0fd8d38c b-gk

// strasbourg  2973783
// paris 2988507
// versailles 2969679

// http://api.openweathermap.org/data/2.5/group?id=2973783,2988507,2969679&appid=f503b4a58a9712074372c8634ef724ae&units=metric



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/weather.service.ts